import { useCallback, useEffect, useRef } from 'react';

export const useDeferredCallback = () => {
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  return useCallback((callback) => {
    Promise.resolve().then(() => {
      if (mounted.current) callback();
    });
  }, []);
};
